import React, { useEffect, useRef } from "react";
import ScrollReveal from "scrollreveal";
import styles from "../services/Services.module.css";

const WHATSAPP_NUMBER = "972505864422";
const waUrl = (t) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(`היי לילך, הגעתי מהאתר שלך ואשמח לשמוע עוד על ${t}`)}`;

const PainSection = () => {
  const sectionRef = useRef(null);

  useEffect(() => {
    if (!sectionRef.current) return;
    const sr = ScrollReveal({
      reset: false,
      distance: "25px",
      duration: 900,
      easing: "cubic-bezier(0.25, 0.46, 0.45, 0.94)",
      viewFactor: 0.1,
    });

    const el = sectionRef.current;
    sr.reveal(el.querySelector('[data-reveal="title"]'), { origin: "top", delay: 100 });
    sr.reveal(el.querySelector('[data-reveal="subtitle"]'), { origin: "top", delay: 200 });

    const cards = el.querySelectorAll('[data-reveal="card"]');
    cards.forEach((card, i) => {
      sr.reveal(card, { origin: "top", delay: 150 + i * 150 });
    });

    sr.reveal(el.querySelector('[data-reveal="bottom"]'), { origin: "top", delay: 100 });

    return () => sr.destroy();
  }, []);

  return (
    <div className={styles.servicesSection} ref={sectionRef}>
      <div className={styles.painSection}>
        <div className={styles.painInner}>
          <h2 className={styles.painTitle} data-reveal="title">מה קורה כשנכנסים לשיפוץ בלי תכנון</h2>
          <p className={styles.painSubtitle} data-reveal="subtitle">הדברים שאף אחד לא מספר לכם - עד שזה כבר עולה כסף</p>

          <div className={styles.painGrid}>
            <div className={styles.painCard} data-reveal="card">
              <span className={styles.painQuote}>"ההצעה של הקבלן נראית הגיונית"</span>
              <p className={styles.painText}>ואז מגלים שהיא לא כוללת חצי מהדברים. אריחים מדוקקים? עבודה כפולה לרצף וחומר יקר. בלי מישהי שמבינה מה ההצעה באמת כוללת - כל שינוי בשטח הופך לחריגה מהתקציב.</p>
            </div>
            <div className={styles.painCard} data-reveal="card">
              <span className={styles.painQuote}>"שמרנו תמונות מפינטרסט - נסתדר"</span>
              <p className={styles.painText}>תמונה יפה לא מבטיחה שהיא מתאימה לבית שלכם, לסגנון החיים שלכם, או שהיא בכלל אפשרית במידות של החלל. מה שנראה מושלם במסך נגמר בתסכול במציאות.</p>
            </div>
            <div className={styles.painCard} data-reveal="card">
              <span className={styles.painQuote}>"מעצבת פנים? נחסוך את הכסף הזה לבית"</span>
              <p className={styles.painText}>ואז טעות אחת באינסטלציה עולה יותר מכל שכר המעצבת. הכסף שחשבתם לחסוך יוצא על תיקון טעויות, בלת"מים, כעסים, וכאבי ראש שאפשר היה למנוע מראש.</p>
            </div>
            <div className={styles.painCard} data-reveal="card">
              <span className={styles.painQuote}>"נתחיל ובדרך נבין"</span>
              <p className={styles.painText}>ואז מגיעים הוויכוחים בין בני הזוג, הספקים שלא עושים את העבודה כמו שצריך, הקבלן שעשה דברים לא במקום - ולא אומרים לכם שיש פתרון פשוט: תכנון מקצועי לפני שנכנסים.</p>
            </div>
          </div>

          <div className={styles.painBottom} data-reveal="bottom">
            <p className={styles.painBottomText}>אנשים משקיעים את רוב כספם בלרכוש בית או לבנות אותו. תכנון נכון מראש חוסך עשרות אלפי שקלים, מונע חודשים של התעסקות - ומוודא שהבית הזה באמת ישרת אתכם.</p>
            <a href={waUrl("תכנון נכון")} target="_blank" rel="noopener noreferrer" className={styles.painCta}>לשיחת ייעוץ ללא עלות לחצו כאן</a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PainSection;
